import axios from 'axios'

// 获取用户历史记录列表
export const getAllWords = (userName, pageNo = 1, pageSize = 10) => {
  return axios.get(`/wordHistory/user/${userName}/list`, {
    params: { pageNo, pageSize }
  })
}

// 根据单词/中文查词或翻译，direction: en2zh 英翻中 | zh2en 中翻英
export const getWordByName = (wordName, direction = 'en2zh') => {
  return axios.get(`/word/${encodeURIComponent(wordName)}/getWord`, {
    params: { direction }
  })
}

// 获取单词/翻译详情
export const getWordDetail = (wordName, direction = 'en2zh') => {
  return axios.get('/word/getWordDetail', {
    params: { wordName, direction }
  })
}

// 添加/更新历史记录
export const addHistory = (userName, wordName) => {
  return axios.post(`/wordHistory/user/${userName}/add`, { wordName })
}

// 删除单条历史记录
export const deleteHistory = (userName, wordName) => {
  return axios.delete(`/wordHistory/user/${userName}/delete/${wordName}`)
}

// 清空历史记录
export const clearHistory = (userName) => {
  return axios.delete(`/wordHistory/user/${userName}/clear`)
}
